const GoogleMap = () => {
    return ( <div>
     
        <iframe
        title="ONPR BURUNDI"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15931.367168092489!2d29.3546855!3d-3.3887853!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa0faf1e70b33d140!2sONPR!5e0!3m2!1sfr!2sbi!4v1653047767737!5m2!1sfr!2sbi"
        width="100%"
        height="200"
        style={{ border: "0" }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>

    
    </div> );
}
 
export default GoogleMap;